// @flow
import React from "react"
import { minHeightImg, selectIndexImage } from "data/images/helpers"
import { Text } from "componentsStyled/Typography/Texts"
import { SubTitle } from "componentsStyled/Typography/Titles"
import { ProductPreviewWrap, ImageWrap, Content } from "./styled"
import ProductDimension from "components/ProductDimension"
import type { ProductVariant } from "data/product/types"
import AffiliateName from "components/AffiliateName"

type Props = {|
  productVariant: ProductVariant,
  affiliateName: string,
|}

const ProductPreview = ({ productVariant, affiliateName }: Props) => {
  const indexImage = selectIndexImage(productVariant.product.images)
  const imageSize = minHeightImg(indexImage, 100)

  return (
    <ProductPreviewWrap>
      <ImageWrap>
        <img src={imageSize.url} alt={indexImage.alt} draggable="false" />
      </ImageWrap>
      <Content>
        <Text>{productVariant.product.manufacturer.name}</Text>
        <SubTitle>{productVariant.product.name}</SubTitle>
        <ProductDimension productVariant={productVariant} compact />
        <AffiliateName name={affiliateName} />
      </Content>
    </ProductPreviewWrap>
  )
}

export default ProductPreview



// WEBPACK FOOTER //
// ./src/components/ProductPreview/index.js